// Detect Tracking Carrier
export const DETECT_TRACKING_CARRIER_REQUEST = 'DETECT_TRACKING_CARRIER_REQUEST';
export const DETECT_TRACKING_CARRIER_DONE = 'DETECT_TRACKING_CARRIER_DONE';
export const DETECT_TRACKING_CARRIER_FAILED = 'DETECT_TRACKING_CARRIER_FAILED';
export const DETECT_TRACKING_CARRIER_RESET = 'DETECT_TRACKING_CARRIER_RESET';
